import { ColorScheme } from '../ColorScheme/ColorScheme';
import { SmoWorld } from './SmoWorld';

export const smoWorldColors: Record<SmoWorld, ColorScheme> = {
  [SmoWorld.capKingdom]: {
    primary: '#424341',
    secondary: '#9BA2A3'
  },
  [SmoWorld.cascadeKingdom]: {
    primary: '#25B05E',
    secondary: '#C19C6C'
  },
  [SmoWorld.sandKingdom]: {
    primary: '#EA5836',
    secondary: '#B84021'
  },
  [SmoWorld.lakeKingdom]: {
    primary: '#6FD1E0',
    secondary: '#8987C0'
  },
  [SmoWorld.woodedKingdom]: {
    primary: '#E16138',
    secondary: '#29794F'
  },
  [SmoWorld.cloudKingdom]: {
    primary: '#CFBAD7',
    secondary: '#C1AEC3'
  },
  [SmoWorld.lostKingdom]: {
    primary: '#B4218A',
    secondary: '#A8372B'
  },
  [SmoWorld.metroKingdom]: {
    primary: '#72747F',
    secondary: '#D5BC06'
  },
  [SmoWorld.snowKingdom]: {
    primary: '#A79DD0',
    secondary: '#E8A68B'
  },
  [SmoWorld.seasideKingdom]: {
    primary: '#2CDCEE',
    secondary: '#ECCD64'
  },
  [SmoWorld.luncheonKingdom]: {
    primary: '#876CD1',
    secondary: '#AB3CD4'
  },
  [SmoWorld.ruinedKingdom]: {
    primary: '#2E2C39',
    secondary: '#EB7AEA'
  },
  [SmoWorld.bowserKingdom]: {
    primary: '#BB3E38',
    secondary: '#CFAB51'
  },
  [SmoWorld.mushroomKingdom]: {
    primary: '#7AD25A',
    secondary: '#DD4D60'
  },
  [SmoWorld.moonKingdom]: {
    primary: '#E4482B',
    secondary: '#772C11'
  }
};
